import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var ViewConfigurationChangedEvent = /*#__PURE__*/function () {
  function ViewConfigurationChangedEvent(source) {
    _classCallCheck(this, ViewConfigurationChangedEvent);

    this.type = 0
    /* ViewConfigurationChanged */
    ;
    this._source = source;
  }

  _createClass(ViewConfigurationChangedEvent, [{
    key: "hasChanged",
    value: function hasChanged(id) {
      return this._source.hasChanged(id);
    }
  }]);

  return ViewConfigurationChangedEvent;
}();
export var ViewCursorStateChangedEvent = function ViewCursorStateChangedEvent(selections, modelSelections) {
  _classCallCheck(this, ViewCursorStateChangedEvent);

  this.type = 1
  /* ViewCursorStateChanged */
  ;
  this.selections = selections;
  this.modelSelections = modelSelections;
};
export var ViewDecorationsChangedEvent = function ViewDecorationsChangedEvent(source) {
  _classCallCheck(this, ViewDecorationsChangedEvent);

  this.type = 2
  /* ViewDecorationsChanged */
  ;

  if (source) {
    this.affectsMinimap = source.affectsMinimap;
    this.affectsOverviewRuler = source.affectsOverviewRuler;
  } else {
    this.affectsMinimap = true;
    this.affectsOverviewRuler = true;
  }
};
export var ViewFlushedEvent = function ViewFlushedEvent() {
  _classCallCheck(this, ViewFlushedEvent);

  this.type = 3
  /* ViewFlushed */
  ; // Nothing to do
};
export var ViewFocusChangedEvent = function ViewFocusChangedEvent(isFocused) {
  _classCallCheck(this, ViewFocusChangedEvent);

  this.type = 4
  /* ViewFocusChanged */
  ;
  this.isFocused = isFocused;
};
export var ViewLanguageConfigurationEvent = function ViewLanguageConfigurationEvent() {
  _classCallCheck(this, ViewLanguageConfigurationEvent);

  this.type = 5
  /* ViewLanguageConfigurationChanged */
  ;
};
export var ViewLineMappingChangedEvent = function ViewLineMappingChangedEvent() {
  _classCallCheck(this, ViewLineMappingChangedEvent);

  this.type = 6
  /* ViewLineMappingChanged */
  ; // Nothing to do
};
export var ViewLinesChangedEvent = function ViewLinesChangedEvent(fromLineNumber, toLineNumber) {
  _classCallCheck(this, ViewLinesChangedEvent);

  this.type = 7
  /* ViewLinesChanged */
  ;
  this.fromLineNumber = fromLineNumber;
  this.toLineNumber = toLineNumber;
};
export var ViewLinesDeletedEvent = function ViewLinesDeletedEvent(fromLineNumber, toLineNumber) {
  _classCallCheck(this, ViewLinesDeletedEvent);

  this.type = 8
  /* ViewLinesDeleted */
  ;
  this.fromLineNumber = fromLineNumber;
  this.toLineNumber = toLineNumber;
};
export var ViewLinesInsertedEvent = function ViewLinesInsertedEvent(fromLineNumber, toLineNumber) {
  _classCallCheck(this, ViewLinesInsertedEvent);

  this.type = 9
  /* ViewLinesInserted */
  ;
  this.fromLineNumber = fromLineNumber;
  this.toLineNumber = toLineNumber;
};
export var ViewRevealRangeRequestEvent = function ViewRevealRangeRequestEvent(source, range, selections, verticalType, revealHorizontal, scrollType) {
  _classCallCheck(this, ViewRevealRangeRequestEvent);

  this.type = 10
  /* ViewRevealRangeRequest */
  ;
  this.source = source;
  this.range = range;
  this.selections = selections;
  this.verticalType = verticalType;
  this.revealHorizontal = revealHorizontal;
  this.scrollType = scrollType;
};
export var ViewScrollChangedEvent = function ViewScrollChangedEvent(source) {
  _classCallCheck(this, ViewScrollChangedEvent);

  this.type = 11
  /* ViewScrollChanged */
  ;
  this.scrollWidth = source.scrollWidth;
  this.scrollLeft = source.scrollLeft;
  this.scrollHeight = source.scrollHeight;
  this.scrollTop = source.scrollTop;
  this.scrollWidthChanged = source.scrollWidthChanged;
  this.scrollLeftChanged = source.scrollLeftChanged;
  this.scrollHeightChanged = source.scrollHeightChanged;
  this.scrollTopChanged = source.scrollTopChanged;
};
export var ViewThemeChangedEvent = function ViewThemeChangedEvent() {
  _classCallCheck(this, ViewThemeChangedEvent);

  this.type = 12
  /* ViewThemeChanged */
  ;
};
export var ViewTokensChangedEvent = function ViewTokensChangedEvent(ranges) {
  _classCallCheck(this, ViewTokensChangedEvent);

  this.type = 13
  /* ViewTokensChanged */
  ;
  this.ranges = ranges;
};
export var ViewTokensColorsChangedEvent = function ViewTokensColorsChangedEvent() {
  _classCallCheck(this, ViewTokensColorsChangedEvent);

  this.type = 14
  /* ViewTokensColorsChanged */
  ; // Nothing to do
};
export var ViewZonesChangedEvent = function ViewZonesChangedEvent() {
  _classCallCheck(this, ViewZonesChangedEvent);

  this.type = 15
  /* ViewZonesChanged */
  ; // Nothing to do
};